// import { IconArrowNarrowRight } from "@tabler/icons-react";
import {
  IconChevronRight,
  IconSpeakerphone,
  IconMapPin,
  IconBriefcase,
  IconArrowNarrowRight,
  IconHome,
  IconClock,
  IconHeartbeat,
  IconCoffee,
  IconUsers,
  IconPlayerPlayFilled,
} from "@tabler/icons-react";

const Aboutus = () => {
  return (
    <div>
      <section className="mt-[71px] bg-[url(../images/banner-bg.png)] bg-cover bg-no-repeat md:mt-[87px] xl:mt-0">
        <div className="bg-primary bg-opacity-40 py-[52px]">
          <div className="container text-n8">
            <h3 className="h3 mb-2.5">About Us</h3>
            <ul className="flex flex-wrap items-center gap-2">
              <li>
                <a href="/" className="home-link">
                  Home
                </a>
              </li>
              <li className="flex items-center">
                <i className="ti ti-chevron-right text-[24px]"></i>
              </li>
              <li>
                <a href="/about-us" className="home-link">
                  About Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="about-section overflow-hidden mt-1">
        <div className="container">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12">
              <div className="container relative">
                <div className="section grid grid-cols-12 items-center justify-center gap-6 xxxl:pb-[259px] xxxl:pt-[230px]">
                  <div className="col-span-12 md:col-span-10 lg:col-span-6"data-aos="fade-right">
                    <div className="section__gap-bottom pb-lg-0">
                      <h5
                        className="h5 mb-5 "
                        style={{ color: "rgb(0, 109, 178)" }}
                      >
                        <i className="ti ti-icon"></i> Boost Creativity with
                        Reliable Tech Solutions
                      </h5>
                      <h3 className="h3 mb-4 text-title">
                        In past years, we've succeeded. Success rewards efforts.
                      </h3>
                      <p className="mb-10 text-lg">
                      At Cognity Info Solutions, we transcend the conventional role of an IT services provider – we stand as your dedicated ally in navigating the intricate realm of technology. Founded with a commitment to empower businesses through cutting-edge solutions, we lead in delivering outstanding IT services crafted to align perfectly with the dynamic requirements of our clients.
                      </p>
                      <a href="/about-us" className="btn-primary">
                        {" "}
                        <IconArrowNarrowRight className="text-blue-600 w-6 h-6" />{" "}
                        Find out More{" "}
                      </a>
                    </div>
                  </div>
                  <div className="relative col-span-12 lg:col-span-6"data-aos="fade-left">
                    <div className="about-img">
                      <div className="-top-40 xxl:absolute xxl:-right-24">
                        <img
                          src="assets/images/about-img-2.webp"
                          alt="image"
                          className="rounded-2xl"
                          width="640"
                          height="394"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="overflow-x-hidden spy120px mt-5"
        style={{ backgroundColor: "#f5f5fd" }}
      >
        <div className="container">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 xl:col-span-6" data-aos="fade-right">
              <div className="about-img relative">
                <div className="top-20 xxl:absolute xxl:-left-24">
                  <img
                    src="assets/images/about-img-2.webp"
                    alt="image"
                    className="rounded-2xl"
                    width="640"
                    height="394"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 xl:col-span-6" data-aos="fade-left">
              <div className="section__gap-top pt-xl-0">
                <span
                  className="h5 lh-1 overlay-text relative isolate inline-block font-semibold mb-3"
                  style={{ color: "rgb(0, 109, 178)" }}
                >
                  {" "}
                  Our mission is to help you grow your business{" "}
                </span>
                <h3 className="h3 mb-3 text-title">
                  Helping clients to bring innovations to life
                </h3>
                <p className="max-text-60 mb-8">
                Cognity Info Solutions is committed to empowering businesses of all sizes to succeed in the digital era. Our goal is to enhance efficiency, foster innovation, and drive growth through comprehensive IT solutions. We place the highest priority on safeguarding our clients' data and systems, ensuring security and integrity in every aspect of our services.
                </p>
                <ul className="grid grid-cols-3 items-center gap-6">
                  <li className="flex-grow-1">
                    <div className="about-3-box rounded-[15px]">
                      <div className="min-w-[196px] rounded-[15px] bg-light px-5 py-2.5">
                        <h4
                          className="h4 mb-1 text-center"
                          style={{ color: "rgb(0, 109, 178)" }}
                        >
                          10+
                        </h4>
                        <p className="text-center">Years of Experience</p>
                      </div>
                    </div>
                  </li>
                  <li className="flex-grow-1">
                    <div className="about-3-box rounded-[15px]">
                      <div className="min-w-[196px] rounded-[15px] bg-light px-5 py-2.5">
                        <h4
                          className="h4 mb-1 text-center"
                          style={{ color: "rgb(0, 109, 178)" }}
                        >
                          500
                        </h4>
                        <p className="text-center">Complete Projects</p>
                      </div>
                    </div>
                  </li>
                  <li className="flex-grow-1">
                    <div className="about-3-box rounded-[15px]">
                      <div className="min-w-[196px] rounded-[15px] bg-light px-5 py-2.5">
                        <h4
                          className="h4 mb-1 text-center"
                          style={{ color: "rgb(0, 109, 178)" }}
                        >
                          100+
                        </h4>
                        <p className="text-center">Employees</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
       {/* <!-- ========== Life at Cognity  ============ --> */}
     
    </div>
  );
};

export default Aboutus;
